import { Modal } from './Modal';
import { Button } from './ui';
import type { ProcessRow } from '../../../../services/databaseMonitor.service';

interface Props {
  row: ProcessRow | null;
  submitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function KillConfirmDialog({ row, submitting, onClose, onConfirm }: Props) {
  return (
    <Modal
      open={!!row}
      onClose={onClose}
      title={row ? `Kill query ${row.id}?` : ''}
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={submitting}>
            {submitting ? 'Killing…' : 'Kill'}
          </Button>
        </>
      }
    >
      {row && (
        <div className="flex flex-col gap-3 text-sm">
          <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1">
            <span className="text-slate-600 dark:text-slate-400">User</span>
            <span>{row.user ?? '—'}</span>
            <span className="text-slate-600 dark:text-slate-400">Host</span>
            <span className="text-xs">{row.host ?? '—'}</span>
            <span className="text-slate-600 dark:text-slate-400">DB</span>
            <span>{row.db ?? '—'}</span>
            <span className="text-slate-600 dark:text-slate-400">Command</span>
            <span>{row.command ?? '—'}</span>
            <span className="text-slate-600 dark:text-slate-400">Time</span>
            <span>{row.time ?? '—'} s</span>
            <span className="text-slate-600 dark:text-slate-400">State</span>
            <span>{row.state ?? '—'}</span>
          </div>
          <div>
            <div className="text-slate-600 dark:text-slate-400 mb-1">Query</div>
            <pre className="bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-md p-3 text-xs whitespace-pre-wrap break-words max-h-48 overflow-auto">
              {row.info ?? '(no query text)'}
            </pre>
          </div>
        </div>
      )}
    </Modal>
  );
}
